import React, { Component } from 'react';
// import { inject , observer} from 'mobx-react'
import { Modal, Button } from 'antd';
import { store } from 'Store/store.index';
// import { cookies } from 'Api/index';

export default class SubscriptionMember extends Component {
  constructor(props) {
    super(props);
    
  }
  switchUser = () => {
    store.loginNewStore.signOut();
    // store.loginNewStore.setIsLogin(false)
    // localStorage.removeItem("token")
    // cookies.remove('fwShareToken', { path: '/' })
    // let logoutHref = `https://webpdfapi.foxitcloud.cn/logout?url=${window.location.href}`
    // store.userNewStore.setUserInfo(null)
    // window.location.href = logoutHref
  }

  render() {
    const { abnormalAccount } = store.userNewStore
    return (
      <React.Fragment>
        <div>
          <Modal
          width="450px"
          visible={abnormalAccount}
          className='abnormalAccountDialog'
          title=' '
          footer = {[]}
          onCancel= {this.switchUser}
          >
            <div className='abnormalAccountDialogMain'>
              <h3>账号异常</h3>
              <p className='text-main'>
                我们发现您的账号在多个设备上登录，本次登录存在安全风险，已被限制登录。若您需要在本设备登录， 请确保在其他设备已经退出或切换一个账号进行重新登录。
              </p>
              <Button key="switchUser" type="primary" onClick={this.switchUser}>切换账号登录</Button>
              <p>联系客服QQ：2852373735</p>
            </div>
          </Modal>
        </div>
      </React.Fragment>
    )
  }
}